<template>
  <div>
    <div class="box">
      <v-server-table
        ref="datatableCharges"
        :url="api"
        :name="tableName"
        :columns="columns"
        :options="options">

        <template slot="beforeTable">
          <datatable-loader :name="tableName" />
        </template>

        <template
          slot="inclusive"
          slot-scope="props">
          <span v-if="props.row.inclusive == null">
            <i class="text-muted">Not set</i>
          </span>
          <span v-if="props.row.inclusive === true">Included in price</span>
          <span v-if="props.row.inclusive === false">Added to price</span>
        </template>

      </v-server-table>

      <div
        id="charge-popup"
        class="modal fade inactive"
        data-backdrop="false">
        <div class="right w-xxxl white b-l">
          <charge-form
            ref="form"
            :charge="charge"/>
        </div>
      </div>

      <add-products-form
        v-if="openProduct"
        ref="addProductsForm"
        :charge-id="chargeId" />

      <add-outlets-form
        v-if="openOutlet"
        ref="addOutletsForm"
        :charge-id="chargeId" />
    </div>
  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import chargeForm from './charge_form.vue';
import addProductsForm from './add-products-form';
import addOutletsForm from './add-outlets-form';
import dateFormatMixin from '../../../mixins/date-format';

const TableName = 'VUETABLE_CHARGE';

export default {
    components: {
        chargeForm,
        addProductsForm,
        addOutletsForm,
    },

    mixins: [dateFormatMixin],

    data() {
        var that = this;
        let canManageTaxes = Auth.hasPermissionTo('franchise_manage_taxes');

        let actionButtons = [
            {
                title: 'Create Charge',
                action: () => {
                    this.show_popup(null);
                },
            },
        ];

        if (!canManageTaxes) {
            actionButtons = [];
        }

        return {
            openProduct: false,
            openOutlet: false,
            chargeId: null,
            charge: null,
            tableName: TableName,
            api: Laroute.route('franchise.inventory.charge.index'),
            columns: [
                'name',
                'amount',
                'scope',
                'effective_at',
                'deactivate_at',
                'products',
                'outlets',
                'status',
            ],
            options: {
                sortable: ['name'],

                texts: {
                    title: 'Charges',
                },

                checkbox: canManageTaxes,

                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.charge.delete',
                    ),
                    delete_title: 'Delete Charges',
                },

                customFilters: ['outlet_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                orderBy: { column: 'name', ascending: 1 },

                headings: {
                    effective_at: 'Effective At',
                    deactivate_at: 'Ineffective At',
                    outlets: 'Stations',
                },

                csv_url: Laroute.route(
                    'franchise.inventory.charge.exportAsFile',
                    { type: 'CSV' },
                ),

                pdf_url: Laroute.route(
                    'franchise.inventory.charge.exportAsFile',
                    { type: 'PDF' },
                ),

                actionButtons: actionButtons,

                rowClassCallback: row => {
                    let clazz = ['pointer'];

                    if (row.status == 0) {
                        clazz.push('text-muted');
                    }

                    return clazz;
                },

                rowClickCallback: that.show_popup,

                templates: {
                    amount: (h, row) => {
                        return require('../tax/amount.jsx')(h, row);
                    },
                    scope: (h, row) => {
                        if (row.scope === 'LINE_ITEM') {
                            return 'Line Item';
                        }

                        return 'Order';
                    },
                    effective_at: (h, row) => {
                        if (row.effective_at) {
                            return this.dateOnly(row.effective_at);
                        }
                    },
                    deactivate_at: (h, row) => {
                        if (row.deactivate_at) {
                            return this.dateOnly(row.deactivate_at);
                        }
                    },
                    products: (h, row) => {
                        return require('./assigned-count')(
                            h,
                            row,
                            row.products.length,
                            'products',
                        );
                    },
                    outlets: (h, row) => {
                        return require('./assigned-count')(
                            h,
                            row,
                            row.outlets.length,
                            'stations',
                        );
                    },
                    status: (h, row) => {
                        return require('./status')(h, row);
                    },
                },
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        searchQuery() {
            return this.$refs.datatableCharges.query;
        },
    },

    watch: {
        activeOutlet: function() {
            this.$store.commit(`${TableName}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: this.activeOutlet,
            });
        },
    },

    created() {
        this.init_charge();
    },

    methods: {
        init_charge() {
            this.charge = {
                id: 0,
                name: '',
                amount: '',
                inclusive: false,
                taxable: false,
                auto_assign_outlet: true,
                mode: 0,
                status: 1,
                outlets: [],
                products: [],
                taxes: [],
                effective_at: moment().startOf('day'),
                deactivate_at: null,
                scope: 'LINE_ITEM',
            };
        },

        get_charge(id) {
            var that = this;
            let api = Laroute.route('franchise.inventory.charge.show', {
                id: id,
            });

            this.chargeId = id;

            this.$http.get(api).then(response => {
                let data = response.data.data;
                that.charge = data;
                that.show_modal();
            });
        },

        show_popup(row) {
            this.closeComponent();

            if (row != null) {
                this.get_charge(row.id);
            } else {
                var that = this;
                this.init_charge();
                setTimeout(() => {
                    this.$refs.form.clearErrorValidation();
                }, 50);
                this.show_modal();
            }
        },

        refresh() {
            this.$store.commit(`${TableName}/SET_FILTER`, this.searchQuery);
        },

        show_modal() {
            this.openComponent();
            $('#charge-popup').modal('show');
        },

        closeComponent() {
            this.openProduct = false;
            this.openOutlet = false;
        },

        openComponent() {
            this.openProduct = true;
            this.openOutlet = true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/charge/vuetable_charge.vue